module.exports = __webpack_public_path__ + "img/model_41_ug.3bb079da.jpg";